import { CommentOutlined } from '@ant-design/icons'
import { Button, Drawer } from 'antd'
import { useDisclosure } from 'hooks/useDisclosure'
import React, { FC, PropsWithChildren } from 'react'

const ChatMenuMobile: FC<PropsWithChildren> = ({ children }) => {
  const { open, isOpen, close } = useDisclosure()
  return (
    <>
      <Button type="text" size="middle" className="w-fit" onClick={open} icon={<CommentOutlined />} />
      <Drawer
        placement="left"
        onClose={close}
        open={isOpen}
        width={300}
        className={'[&_.ant-drawer-header-title]:!flex-row-reverse'}
      >
        {React.Children.map(children, (child) =>
          React.cloneElement(child as React.ReactElement<any>, { onClick: close })
        )}
      </Drawer>
    </>
  )
}

export default ChatMenuMobile
